import React from 'react';
import authService from '../../api-authorization/AuthorizeService'
import axios from 'axios'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import createCache from '@emotion/cache';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function DisplayPlayerProfile({ player }) {
    return (
        <div className="mt-10 mb-10">
            { 
                <Box sx={{ pt: 1, pb: 1 }}>
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
                        <Grid item xs={12} lg={6}>
                            <Card sx={{}}>
                                {/*<CardMedia*/}
                                {/*    sx={{ height: 140 }}*/}
                                {/*    image="/static/images/cards/contemplative-reptile.jpg"*/}
                                {/*    title="green iguana"*/}
                                {/*/>*/}
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div" color="text.primary">
                                        FIDE Profile :   {player.fidePlayerId > 0 ? player.fideName : "Player has no FIDE ID"}
                                    </Typography>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Membership</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">
                                                    {player.fidePlayerId > 0 ?
                                                        <span>
                                                            <a rel="noreferrer" href={'https://ratings.fide.com/profile/' + player.fidePlayerId} target='_blank' rel='noreferrer'>{player.fidePlayerId}</a>
                                                            <span>[</span>
                                                            <a rel="noreferrer" href={'https://chess-results.com/PartieSuche.aspx?lan=1'} target='_blank' rel='noreferrer'>{player.fideSex}</a>
                                                            <span>,</span>
                                                            <a rel="noreferrer" href={'https://ratings.fide.com/view_games.phtml?id=' + player.fidePlayerId} target='_blank' rel='noreferrer'>{player.fideBirthday}</a>
                                                            <span>]</span>
                                                        </span>
                                                        :
                                                        "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Country</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{player.fidePlayerId > 0 ?player.fideCountry : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">OTB Rating</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{player.fidePlayerId > 0 ? "Regular " + player.fideRating + " [K" + player.fidekValue + "] | Blitz " + player.fideBlitzRating + " [K" + player.fideBlitzKValue + "] | Rapid " + player.fideRapidRating + " [K" + player.fideRapidKValue + "] ": "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Title</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{player.fidePlayerId > 0 ? player.fideTitle : "N/A"} {player.fidePlayerId > 0 ? player.fideWomenTitle : ""} {player.fidePlayerId > 0 ? player.fideOtherTitle : ""}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Card sx={{}}>
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div" color="text.primary">
                                        USCF Profile :   {player.uscfPlayerId > 0 ? player.uscfName : "Player has no USCF ID"}
                                    </Typography>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Membership</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">
                                                    {player.uscfPlayerId > 0 ?
                                                        <span>
                                                            <a rel="noreferrer" href={'https://www.uschess.org/msa/MbrDtlTnmtHst.php?' + player.uscfPlayerId} target='_blank' rel='noreferrer'>{player.uscfPlayerId}</a>
                                                            <span>[Exp </span>
                                                            <a rel="noreferrer" href={'https://www.uschess.org/msa/MbrDtlMain.php?' + player.uscfPlayerId} target='_blank' rel='noreferrer'>{player.uscfExpDate.split("T")[0]}</a>
                                                            <span>]</span>
                                                        </span>
                                                        :
                                                        "N/A"
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">State</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{player.uscfPlayerId > 0 ? player.uscfState: "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">OTB Rating</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{player.uscfPlayerId > 0 ? "Regular "+player.uscfRating+" | Blitz "+player.uscfBlitzRating+" | Quick "+player.uscfQuickRating : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Online Rating</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{player.uscfPlayerId > 0 ? "Regular " + player.uscfOnlineRating + " | Blitz " + player.uscfOnlineBlitzRating + " | Quick " + player.uscfOnlineQuickRating : "N/A"}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
                }
        
        </div>
    )
}
